<template>
    <div class="qksm qksm12">
        <h4>十二、政府采购支出决算情况说明</h4>
        <div class="nogap">
            <p>
                2020年度政府采购支出总额{{isMoney(T12.总计)}}万元，其中：政府采购货物支出{{isMoney(T12.货物)}}万元、政府采购工程支出{{isMoney(T12.工程)}}万元、政府采购服务支出{{isMoney(T12.服务)}}万元。
                授予中小企业合同金额<reason type="money" classname="qksm money" name="中小企业合同" v-model:value="qksm['中小企业合同']"></reason>万元，
                占政府采购支出总额的{{calcRatio(qksm['中小企业合同'],T12.总计)}},
                其中：授予小微企业合同金额<reason type="money" classname="qksm money" name="小微企业合同" v-model:value="qksm['小微企业合同']"></reason>万元，
                占政府采购支出总额的{{calcRatio(qksm['小微企业合同'],T12.总计)}}。
            </p>
        </div>
    </div>
</template>
<script>
    import reason from "@/components/reason.vue";
    export default {
        name: "qksm12",
        props: {
            T12: {
                type: Object,
                default: "",
            },
        },
        components: {
            reason,
        },
        data() {
            return {
                isPdf: this.$parent.isPdf,
                qksm: this.$store.state.divData.qksm
            }
        },
        created() {
            this.inspect()
        },
        updated: function () {
            this.inspect()
        },
        methods: {
            inspect() {
                if (this.$store.state.divData.zone != "gusu") {
                    if (this.num(this.qksm['中小企业合同']) > this.num(this.T12.总计)) {
                        this.addOrSet("qksm921", "请检查本页《十二、政府采购支出决算情况说明》中填写的授予中小企业合同金额应该小于等于政府采购支出总额。");
                    } else {
                        this.remove("qksm921")
                    }
                }
                if (this.num(this.qksm['小微企业合同']) > this.num(this.qksm['中小企业合同'])) {
                    this.addOrSet("qksm922", "请检查本页《十二、政府采购支出决算情况说明》中填写的授予小微企业合同金额应该小于等于填写的授予中小企业合同金额。");
                } else {
                    this.remove("qksm922")
                }
            }
        }
    };
</script>
